import type { CSSProperties, ReactNode } from 'react';
import { cx } from '../utils/cx';

export interface SkeletonProps {
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  shape?: 'rect' | 'circle';
  className?: string;
}

/** Bloc de substitution décoratif : n'est jamais annoncé seul (voir LoadingRegion). */
export function Skeleton({
  width = '100%',
  height = 16,
  shape = 'rect',
  className,
}: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={cx('av-skeleton', shape === 'circle' && 'av-skeleton--circle', className)}
      style={{ width, height }}
    />
  );
}

/**
 * Zone en cours de chargement réel : annonce un libellé aux lecteurs d'écran et affiche des
 * squelettes. À n'utiliser que pendant une requête effective (aucun faux chargement).
 */
export function LoadingRegion({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div role="status" aria-busy="true">
      <span className="av-visually-hidden">{label}</span>
      {children}
    </div>
  );
}
